import DeletePopup, {
  PopupProps,
  AlertModal as ReExportedAlertModal,
} from "../Dashboard/Folder/DeletePopup";

export type AlertModalProps = PopupProps;
export const AlertModal = ReExportedAlertModal;
export default DeletePopup;
